import { createSlice } from "@reduxjs/toolkit";
import { BuscaPlanoContaFinanceiroModel } from "../../../models/planoContaFinanceiro/buscaPlanoContaFinanceiroModel";
import { PlanoContaFinanceiroDTOModel } from "../../../models/planoContaFinanceiro/planoContaFinanceiroDTOModel";
import { PlanoContaFinanceiroModel } from "../../../models/planoContaFinanceiro/planoContaFinanceiroModel";
import { SelectModel } from "../../../models/treeModel";
import { HistoricoPlanoContaFinanceiroModel } from "../../../models/planoContaFinanceiro/historicoPlanoContaFinanceiroModel";
import {
  buscarPlanoContaFinanceiro,
  // buscarPlanoContaFinanceiroAtivosGrupoTreeSelect,
  listarHistoricoPlanoContaFinanceiro,
  // listarPlanoContaFinanceiroAtivos,
  // listarPlanoContaFinanceiroAtivosTreeSelect,
} from "../../../services/planoContaFinanceiroService";
import { resetAll } from "../../actions/actions";

export interface PlanoContaFinanceiroState {
  //buscar plano conta financeiro
  loading: boolean;
  busca: BuscaPlanoContaFinanceiroModel;
  list: PlanoContaFinanceiroDTOModel[];
  entity: PlanoContaFinanceiroModel;
  //buscar plano conta financeiro historico
  loadingHistorico: boolean;
  listHistorico: HistoricoPlanoContaFinanceiroModel[];
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
  modalHistorico: boolean;
  // cadastroSelect: CadastroSelectModel;
}

const initialState: PlanoContaFinanceiroState = {
  //buscar plano conta financeiro
  loading: false,
  busca: {
    pesquisar: null,
    receitaDespesa: null,
    ativo: null,
    usoSistema: null,
    idGrupoPlanoContaFinanceiro: null,
  },
  list: [],
  entity: {} as PlanoContaFinanceiroDTOModel,
  //buscar plano conta financeiro historico
  loadingHistorico: false,
  listHistorico: [],
  //internal
  modalCadastrar: false,
  modalDeletar: false,
  modalHistorico: false,
};

export const planoContaFinanceiroSlice = createSlice({
  name: "planoContaFinanceiro",
  initialState,
  reducers: {
    //buscar plano conta financeiro
    setBuscaPlanoContaFinanceiro: (state, action) => {
      state.busca = action.payload;
    },
    setEntityPlanoContaFinanceiro: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarPlanoContaFinanceiro: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarPlanoContaFinanceiro: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalHistoricoPlanoContaFinanceiro: (state, action) => {
      state.modalHistorico = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar plano conta financeiro
    builder.addCase(buscarPlanoContaFinanceiro.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPlanoContaFinanceiro.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPlanoContaFinanceiro.rejected, (state, action) => {
      state.loading = false;
    });

    // //buscar plano conta financeiro ativos grupo tree select
    // builder.addCase(buscarPlanoContaFinanceiroAtivosGrupoTreeSelect.pending, (state) => {
    //   state.loadingGrupo = true;
    // });
    // builder.addCase(buscarPlanoContaFinanceiroAtivosGrupoTreeSelect.fulfilled, (state, action) => {
    //   state.listGrupo = action.payload;
    //   state.loadingGrupo = false;
    // });
    // builder.addCase(buscarPlanoContaFinanceiroAtivosGrupoTreeSelect.rejected, (state, action) => {
    //   state.loadingGrupo = false;
    // });

    // //buscar plano conta financeiro ativos
    // builder.addCase(listarPlanoContaFinanceiroAtivos.pending, (state) => {
    //   state.loadingAtivos = true;
    // });
    // builder.addCase(listarPlanoContaFinanceiroAtivos.fulfilled, (state, action) => {
    //   state.listAtivos = action.payload;
    //   state.loadingAtivos = false;
    // });
    // builder.addCase(listarPlanoContaFinanceiroAtivos.rejected, (state, action) => {
    //   state.loadingAtivos = false;
    // });

    // //buscar plano conta financeiro ativos tree select
    // builder.addCase(listarPlanoContaFinanceiroAtivosTreeSelect.pending, (state) => {
    //   state.loadingSelect = true;
    // });
    // builder.addCase(listarPlanoContaFinanceiroAtivosTreeSelect.fulfilled, (state, action) => {
    //   state.listSelect = action.payload;
    //   state.loadingSelect = false;
    // });
    // builder.addCase(listarPlanoContaFinanceiroAtivosTreeSelect.rejected, (state, action) => {
    //   state.loadingSelect = false;
    // });

    //buscar plano conta financeiro historico
    builder.addCase(listarHistoricoPlanoContaFinanceiro.pending, (state) => {
      state.loadingHistorico = true;
    });
    builder.addCase(listarHistoricoPlanoContaFinanceiro.fulfilled, (state, action) => {
      state.listHistorico = action.payload;
      state.loadingHistorico = false;
    });
    builder.addCase(listarHistoricoPlanoContaFinanceiro.rejected, (state, action) => {
      state.loadingHistorico = false;
    });
  },
});

export const {
  //buscar plano conta financeiro
  setBuscaPlanoContaFinanceiro,
  setEntityPlanoContaFinanceiro,
  //internal
  setModalCadastrarPlanoContaFinanceiro,
  setModalDeletarPlanoContaFinanceiro,
  setModalHistoricoPlanoContaFinanceiro,
  // setCadastroSelect,
} = planoContaFinanceiroSlice.actions;

export default planoContaFinanceiroSlice.reducer;
